import * as Icons from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, staggerContainer, staggerItem } from "./Reveal";
import { VALUES } from "../data/site";

export const WhyInceptica = () => {
  return (
    <section id="why" data-testid="why-section" className="relative py-24 lg:py-32 bg-zinc-50 border-y border-zinc-200">
      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-blue-600">
            Why Inceptica
          </span>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-zinc-900">
            A product company, engineered for trust
          </h2>
        </Reveal>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {VALUES.map((v) => {
            const Icon = Icons[v.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={v.id}
                variants={staggerItem}
                whileHover={{ y: -4 }}
                data-testid={`value-card-${v.id}`}
                className="group relative overflow-hidden rounded-2xl border border-zinc-200 bg-white p-7 shadow-sm hover:shadow-lg hover:border-blue-300 transition-shadow"
              >
                <div className="absolute inset-x-0 -top-px h-px bg-gradient-to-r from-transparent via-blue-500/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <Icon className="w-6 h-6 text-blue-600" />
                <h3 className="mt-5 font-display text-lg font-medium text-zinc-900">
                  {v.title}
                </h3>
                <p className="mt-2.5 text-sm text-zinc-600 leading-relaxed">
                  {v.description}
                </p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
